<template>
  <div class="main-wrapper">
    <!-- List -->
    <Accounts @tab="(value) => {
        selectTab(value);
      }
        " :filter="accountPageFilter" @onFilter="(data) => accountPageFilter = data"
      v-if="switch_tab == 'accounts'">
    </Accounts>


    <!-- Account Contacts -->
    <AccountContacts @tab="(value) => {
        selectTab(value);
      }
        " @onFilter="(data) => accountContactPageFilter = data" :filter="accountContactPageFilter"
      v-if="switch_tab == 'account_contacts'"></AccountContacts>


    <!-- Lia Contacts -->
    <LIAContacts @tab="(value) => {
        selectTab(value);
      }
        " @onFilter="(data) => liaContactPageFilter = data" :filter="liaContactPageFilter"
      v-if="switch_tab == 'lia_contacts'"></LIAContacts>
  </div>
</template>
<script>
import Accounts from "@/views/Accounts/Accounts.vue";
import AccountContacts from "@/views/Accounts/AccountContacts.vue";
import LIAContacts from "@/views/Accounts/LIAContacts.vue";
export default {
  name: "customer",
  components: {
    Accounts,
    AccountContacts,
    LIAContacts,
  },
  data() {
    return {
      switch_tab: "accounts",
      accountPageFilter: null,
      accountContactPageFilter: null,
      liaContactPageFilter: null,
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      if (val) {
        vm.switch_tab = val;
      } else {
        vm.switch_tab = "accounts";
      }
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Accounts",
      },
    ];
    vm.$store.commit("SET_PATH", path);
    if (vm.$route.params.type) {
      vm.switch_tab = vm.$route.params.type;
    }
  },
  methods: {
    selectTab(type) {
      let vm = this;
      let path = [];
      if (type == "contacts") {
        path = [
          {
            label: "Account",
            path: "/accounts/list",
          },
          {
            label: type,
            active: true,
          },
        ];
      } else if (type == "accounts") {
        path = [
          {
            label: "Account",
          },
        ];
      }
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({
          name: "accounts",
          params: { type: type },
        })
        .catch((error) => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
}
</style>
